import NotificationsPage from './pages/Notifications.page';

NotificationsPage.path = '/alerts';

export default {
  pages: {
    NotificationsPage,
  }
};
